// extracted by mini-css-extract-plugin
export var changelogSubtitle = "release-note-preview-module--changelog-subtitle--Zqaal";
export var meta = "release-note-preview-module--meta--DMaod";
export var releaseNote = "release-note-preview-module--release-note--sD6jv";